var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatteryShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m7.5,32c-2.21,0-4-1.79-4-4V10c0-2.21,1.79-4,4-4h34c2.21,0,4,1.79,4,4v3h5v12h-5v3c0,2.21-1.79,4-4,4H7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    d: "m41.5,7c1.65,0,3,1.35,3,3v4h5v10h-5v4c0,1.65-1.35,3-3,3H7.5c-1.65,0-3-1.35-3-3V10c0-1.65,1.35-3,3-3h34m0-2H7.5c-2.76,0-5,2.24-5,5v18c0,2.76,2.24,5,5,5h34c2.76,0,5-2.24,5-5v-2h5v-14h-5v-2c0-2.76-2.24-5-5-5h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 54,
    height: 38
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryShape);
export default __webpack_public_path__ + "static/media/battery_shape.e38691a286723f16c9c7e72b68330204.svg";
export { ForwardRef as ReactComponent };